import axios from "axios";

// const api = 'https://sspd1z8jy0.execute-api.us-east-1.amazonaws.com/prod';

const api = process.env.REACT_APP_API_PROTOCOLOS || "";
const apiKey = process.env.REACT_APP_KEY_PROTOCOLS || "";

const consultarProtocolo = async (
  startDate = null,
  endDate = null,
  lastEvaluatedKey = null,
  token
) => {
  const path = "/protocols"; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const params = {
      startDate,
      endDate,
      limit: 300,
    };

    // Agregar startKey solo si lastEvaluatedKey no es null
    if (lastEvaluatedKey !== null) {
      params.startKey = JSON.stringify(lastEvaluatedKey);
    }

    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": apiKey,
      },
      params,
    });

    return response.data; // Devuelve los datos obtenidos
  } catch (error) {
    console.error("Error en la consulta:", error);
    throw error; // Relanza el error para que se maneje en otro lugar si es necesario
  }
};

const crearProtocolo = async (registro, token) => {
  const path = `/protocols`; // Ruta del evento específico
  const apiUrl = `${api}${path}`; // Ruta del evento específico

  try {
    const response = await axios.post(apiUrl, registro, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-api-key": apiKey,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const EditarProtocolo = async (eventId, protocolId, registro, token) => {
  const path = `/protocols`; // Ruta del evento específico

  // Codificamos los valores para que no rompan la URL
  const encodedEventId = encodeURIComponent(eventId);
  const encodedProtocolId = encodeURIComponent(`#${protocolId}`);

  const apiUrl = `${api}${path}/${encodedEventId}${encodedProtocolId}`;

  try {
    const response = await axios.patch(apiUrl, registro, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-api-key": apiKey,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const protocolosService = {
  crearProtocolo,
  consultarProtocolo,
  EditarProtocolo,
};

export default protocolosService;
